export const UPDATE_PROCESS_STATEMENTS_REQUEST = 'UPDATE_PROCESS_STATEMENTS_REQUEST';

export const updateProcessStatementsRequest = ( entries = [] ) => ({
    type: UPDATE_PROCESS_STATEMENTS_REQUEST,
    payload: { entries  }
});
